import type React from 'react'
import type {SearchResults, SearchResultsType} from '../../types/blackbird-types'
import {Text, Box} from '@primer/styled-react'
import {Octicon} from '@primer/styled-react/deprecated'
import {LightBulbIcon} from '@primer/octicons-react'
import {useStableRandom} from '@github-ui/use-stable-random'

interface Tip {
  content: React.ReactElement | number | string
  show: SearchResultsType[]
}

const tips: Tip[] = [
  {
    content: (
      <>
        Press the{' '}
        <Box sx={{display: 'inline-block'}} className="hx_kbd">
          /
        </Box>{' '}
        key to activate the search input again and adjust your query.
      </>
    ),
    show: [
      'code',
      'codelegacy',
      'repositories',
      'commits',
      'issues',
      'pullrequests',
      'discussions',
      'registrypackages',
      'topics',
      'wikis',
      'users',
      'marketplace',
    ],
  },
  {
    content: 'Restrict your search to the title by using the in:title qualifier.',
    show: ['issues', 'pullrequests'],
  },
]

export default function MiniTip({payload}: {payload: SearchResults}) {
  const type = payload.type
  const tipsForType = tips.filter(tip => tip.show.includes(type))
  const tipIndex = useStableRandom({max: tipsForType.length || 1})
  const randomTip = tipsForType[tipIndex]

  if (!randomTip) {
    return null
  }
  return (
    <Box sx={{fontSize: 0, color: 'fg.muted', p: [3, 3, 0, 0]}}>
      <Box sx={{display: 'inline-block', color: 'attention.fg'}}>
        <Octicon icon={LightBulbIcon} size={16} sx={{color: 'attention.fg'}} />
        <Text sx={{pl: 1, fontWeight: 'bold'}}>ProTip!</Text>&nbsp;
      </Box>
      <span>{randomTip.content}</span>
    </Box>
  )
}
